import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import decode from "jwt-decode";
import logo from "../../assets/logo (1).png";
import search from "../../assets/search-solid.svg";
import Avatar from "../../components/Avatar/Avatar";
// import Button from "../../components/Button/Button";
import "./Navbar.css";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentUser } from "../../actions/currentUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faWindowClose } from "@fortawesome/free-solid-svg-icons";

const Navbar = ({ showNav, handleShowNav }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  var User = useSelector((state) => state.currentUserReducer);
  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
    navigate("/");
    dispatch(setCurrentUser(null));
  };

  useEffect(() => {
    const token = User?.token;
    if (token) {
      const decodedToken = decode(token);
      if (decodedToken.exp * 1000 < new Date().getTime()) {
        handleLogout();
      }
    }
    dispatch(setCurrentUser(JSON.parse(localStorage.getItem("Profile"))));
  }, [dispatch]);

  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        autoDisplay: false,
      },
      "google_translate_element"
    );
  };

  useEffect(() => {
    var addScript = document.createElement("script");

    addScript.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";

    // addScript?.setAttribute(
    //   "src",
    //   "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    // );

    const identifier = setTimeout(() => {
      document.body.appendChild(addScript);
    }, 300);
    window.googleTranslateElementInit = googleTranslateElementInit;
    return () => {
      clearTimeout(identifier);
    };
  }, []);

  return (
    <nav className="main-nav">
      <div className="navbar">
        <nav>
          <button className="showNav-button" onClick={handleShowNav}>
            {!showNav ? (
              <FontAwesomeIcon icon={faBars} className="fa-2x" />
            ) : (
              <FontAwesomeIcon icon={faWindowClose} className="fa-2x" />
            )}
          </button>

          <div
            className={showNav ? "navigation-menu expanded" : "navigation-menu"}
          >
            <ul>
              <Link to="/" className="navigation-links">
                <p>Home</p>
              </Link>
              <div>
                <Link to="/Questions" className="navigation-links">
                  <p>Questions</p>
                </Link>
                <Link to="/Tags" className="navigation-links">
                  <p>Tags</p>
                </Link>
                <Link to="/Users" className="navigation-links">
                  <p>Users</p>
                </Link>
              </div>
            </ul>
          </div>
        </nav>

        <Link to="/" className="nav-item nav-logo">
          <img src={logo} alt="logo" />
        </Link>
        <Link to="/" className="nav-item nav-btn">
          About
        </Link>
        <Link to="/" className="nav-item nav-btn">
          Products
        </Link>
        <Link to="/" className="nav-item nav-btn">
          For Teams
        </Link>

        <form className="search">
          <input type="text" placeholder="Search..." />
          <img src={search} alt="search" width="18" className="search-icon" />
        </form>

        <div
          id="google_translate_element"
          style={{ textAlign: "center" }}
          className="gt-2"
        ></div>

        {User === null ? (
          <Link to="/Auth" className="nav-item nav-links">
            Log in
          </Link>
        ) : (
          <>
            <Avatar
              backgroundColor="#009dff"
              px="10px"
              py="7px"
              borderRadius="50%"
              color="white"
            >
              <Link
                to={`/Users/${User?.result?._id}`}
                style={{ color: "white", textDecoration: "none" }}
              >
                {User.result.name.charAt(0).toUpperCase()}
              </Link>
            </Avatar>
            <button className="nav-item nav-links" onClick={handleLogout}>
              Log out
            </button>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
